import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {
  Spinner, NonIdealState
} from '@blueprintjs/core';
import { Helmet } from 'react-helmet';
import styled from '@emotion/styled';
import Quote from 'components/Quote/Quote';

const CardHolder = styled('div')`
  padding: ${props => `${props.theme.unit*3}px`};
`

@inject('quoteStore') @observer
class ReviewQuote extends Component {

  componentWillMount() {
    const {
      props: {
        quoteStore,
      }
    } = this;
    quoteStore.loadQuoteToReview()
  }

  render() {
    let content;
    const {
      quoteStore: {
        quote: {
          isLoading,
          isError,
          object
        }
      }
    } = this.props;

    if (isLoading && !isError) {
      content =  <CardHolder><Spinner/></CardHolder>;
    }
    if (isError && !isLoading) {
      content = <NonIdealState title="Failed" description="Sorry, something went wrong" />;
    }

    if (!isError && !isLoading && object && object.attributes && object.attributes.id) {
      content = <Quote />
    }
    return(
      <React.Fragment>
        <Helmet>
          <title>{(object && object.attributes && object.attributes.tenant.name) || ' '} | FieldNexus</title>

        </Helmet>
        {content}
      </React.Fragment>
    )
  }
};

export default ReviewQuote;